export default "__VITE_ASSET__Baou1qOE__"